import * as Yup from "yup";
import { getPatchOperations } from "../../../util/form";

export const adminInteresserFormConfig = (
  id?: string,
): FormConfig<InteresseDTO> => {
  return {
    title: "interesse",
    lockedValues: [{ id: "id", value: id }],
    validationSchema: Yup.object({
      navn: Yup.string().required("Påkrævet"),
      forkortelse: Yup.string().required().max(3, "Maks 3 tegn"),
    }),
    form: [
      {
        component: "textinput",
        id: "navn",
        initialValue: "",
        label: "Navn",
        placeholder: "",
        isRequired: true,
      },
      {
        component: "textinput",
        id: "forkortelse",
        initialValue: "",
        label: "Forkortelse",
        placeholder: "",
        isRequired: false,
      },
      {
        component: "textinput",
        id: "beskrivelse",
        initialValue: "",
        label: "Beskrivelse",
        placeholder: "",
        isRequired: false,
      },
    ],
    get: `interesser/${id}`,
    post(values) {
      return {
        query: `interesser`,
        body: values,
      };
    },
    patch(values) {
      return {
        query: `interesser/${id}`,
        body: JSON.stringify(getPatchOperations(values)),
      };
    },
    delete() {
      return {
        query: `interesser/${id}`,
      };
    },
    errorStatusCodeMessages: {
      409: "Interessen kan ikke slettes, da det har reference til en person",
    },
  };
};
